var noop = function () { };
var isAboutSame = function (a, b, px) { return Math.abs(a - b) <= px; };

export { isAboutSame as i, noop as n };
//# sourceMappingURL=bundle-fBRojj0w.js.map
